import { ConnectionTest, ConnectionTestGroup, eltbit } from "../visual/domutils";

/* The string values of these enums are used as CSS classes, and so must match what our CSS expects. */
export enum TestState {
    InProgress = 'inprogress',
    Ok = 'ok',
    Uncertain = 'maybe',
    Fatal = 'failed'
}

export interface TestGroup {
    addChild: (child: ConnectionTest | ConnectionTestGroup) => void;
    queueRerender: () => void;
}

export class TestDisplayer {
    identifier: string
    status: TestState
    summary: eltbit[]
    short?: string
    details?: eltbit[][]

    queueRerender: () => void

    constructor(parent: { queueRerender: () => void }, identifier: string) {
        this.queueRerender = parent.queueRerender
        this.identifier = identifier
        this.status = TestState.InProgress
        this.summary = []
    }

    noteStatus(state: TestState, ...summary: eltbit[]) {
        this.status = state
        if (summary) {
            this.summary = summary
        }
        this.queueRerender()
    }

    noteDetail(...summary: eltbit[]) {
        if (!this.details || !Object.prototype.hasOwnProperty.call(this, 'details')) {
            this.details = [ summary ]
        } else {
            this.details!.push(summary)
        }
    }

    noteShort(short: string) {
    	this.short = short
    }
}

function overallStatus(tests: Array<{status: TestState}>): TestState {
    const states = tests.map( s => s.status )

    if (states.indexOf(TestState.Fatal) >= 0) {
        return TestState.Fatal;
    } else if (states.indexOf(TestState.InProgress) >= 0) {
        return TestState.InProgress;
    } else if (states.indexOf(TestState.Uncertain) >= 0 || states.indexOf(TestState.Ok) < 0) {
        return TestState.Uncertain;
    } else {
        return TestState.Ok;
    }
}

export {
    overallStatus,
}
